<!-- Agent owns authentication; the shared service row owns provider presentation. -->
<div class="cli">
  <!-- Codex CLI — sign in with ChatGPT (device-code, one-time, from the web app). -->
  <app-service-provider-row name="Codex CLI" description="Use OpenAI Codex with your ChatGPT account."
    [selected]="agentStatus?.enabled ? agentStatus?.authenticated === true : null">
    <ng-container provider-actions *ngIf="agentStatus?.enabled">
      <button type="button" class="br-btn br-btn--ghost br-btn--sm"
              *ngIf="!agentStatus?.authenticated && !device"
              [disabled]="connecting || disconnecting" (click)="connectAgent()">
        <br-icon>link</br-icon>{{ connecting ? 'Starting…' : 'Sign in with ChatGPT' }}
      </button>
      <!-- Connected: chevron on top, Sign out folds out directly below it. -->
      <ng-container *ngIf="agentStatus?.authenticated">
        <div class="br-flex br-items-center br-gap-1">
          <span class="br-small br-text-muted" role="status">Connected</span>
          <button type="button" class="br-btn br-btn--ghost br-btn--sm br-icon-btn"
                  (click)="toggleExpanded()" [attr.aria-expanded]="expanded" title="Sign out">
            <br-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</br-icon>
          </button>
        </div>
        <button type="button" class="br-btn br-btn--ghost br-btn--sm" *ngIf="expanded"
                [disabled]="disconnecting || connecting" (click)="disconnectAgent()">
          <br-icon>logout</br-icon>{{ disconnecting ? 'Signing out…' : 'Sign out' }}
        </button>
      </ng-container>
    </ng-container>
  </app-service-provider-row>

  <!-- Cached state stays visible during background refresh. -->
  <p class="cli-note br-text-muted" *ngIf="agentLoading && !agentStatus" role="status">Checking connection�</p>
  <p class="cli-note br-text-muted" *ngIf="agentStatus?.runtimeRunning === false">Runtime is not running. Sign-in status is unknown.</p>
  <!-- Host configuration / transient messages. -->
  <p class="cli-note br-text-muted" *ngIf="agentStatus && !agentStatus.enabled">
    {{ problem?.message || 'AI Agent is not configured on this server.' }}
  </p>
  <p class="cli-note br-alert br-alert--danger" *ngIf="connectError">{{ connectError }}</p>
  <div class="cli-note br-flex br-items-center br-flex-wrap br-gap-2" *ngIf="problem || connectError">
    <span class="br-small br-text-muted" *ngIf="problem?.diagnosticId">Diagnostic ID: <code>{{ problem?.diagnosticId }}</code></span>
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
            [disabled]="agentLoading || connecting || disconnecting" (click)="loadAgentStatus()">Check connection</button>
  </div>
  <p class="cli-note br-alert br-alert--danger" *ngIf="expired">Code expired before approval — start again.</p>

  <!-- Pending: the device code, where to enter it, and a cancel. Poll until approved. -->
  <div class="agent-device" *ngIf="device">
    <p class="agent-device-lead">1. Copy this one-time code:</p>
    <div class="agent-code-row">
      <span class="agent-code">
        <span class="agent-code-cell" [class.agent-code-dash]="ch === '-'"
              *ngFor="let ch of codeChars">{{ ch }}</span>
      </span>
      <button type="button" class="br-btn br-btn--ghost br-icon-btn agent-copy" [class.agent-copy-done]="copied"
              [title]="copied ? 'Copied' : 'Copy code'" (click)="copyCode()">
        <br-icon>{{ copied ? 'check' : 'content_copy' }}</br-icon>
      </button>
    </div>
    <p class="agent-device-hint">
      2. Go to
      <a class="agent-open" [href]="device.url" target="_blank" rel="noopener">{{ device.url }},</a>
    </p>
    <p>enter the code and sign with your ChatGPT account.</p>
    <div class="agent-waiting"><span class="agent-spinner" aria-hidden="true"></span>waiting for approval...<button type="button" class="br-btn br-btn--ghost" (click)="cancelConnect()">Cancel</button></div>
  </div>

  <!-- Claude CLI — placeholder (not yet available). -->
  <app-service-provider-row name="Claude CLI" description="Use Anthropic Claude Code with your Anthropic account." [comingSoon]="true"></app-service-provider-row>
</div>
